import { useForm } from "react-hook-form";
import "styles/cadastro.css";
import { useState } from "react";
import { SignUpData } from "types/auth";

type IORFormData = {
  descIOR: string;
  nomeIOR: string;
  emailIOR: string;
  tipoIOR: string;
  paisIOR: string;
  estadoIOR: string;
  cidadeIOR: string;
  enderecoIOR: string;
  numeroIOR: string;
  cod_postalIOR: string;
  telefoneIOR: string;
  state_tax_idIOR: string;
};

type Props = {
  data: SignUpData;
  onNext: (p: Partial<SignUpData>) => void;
  onBack: () => void;
};

export default function StepIOR({ data, onNext, onBack }: Props) {
  const { register, handleSubmit } = useForm<IORFormData>({
    defaultValues: {
      descIOR: data.descIOR ?? "",
      nomeIOR: data.nomeIOR ?? "",
      emailIOR: data.emailIOR ?? "",
      tipoIOR: data.tipoIOR ?? "",
      paisIOR: data.paisIOR ?? "US",
      estadoIOR: data.estadoIOR ?? "",
      cidadeIOR: data.cidadeIOR ?? "",
      enderecoIOR: data.enderecoIOR ?? "",
      numeroIOR: data.numeroIOR ?? "",
      cod_postalIOR: data.cod_postalIOR ?? "",
      telefoneIOR: data.telefoneIOR ?? "",
      state_tax_idIOR: data.state_tax_idIOR ?? "",
    },
  });

  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  const onSubmit = async (values: IORFormData) => {
    setLoading(true);
    setErro(null);
    onNext({ ...values });
    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <p className="cadastro-rotulo" style={{ marginBottom: "1rem", opacity: 0.7 }}>
        Optional — fill in only if you have a US Importer of Record (IOR).
      </p>
      <div className="cadastro-grid-campos">
        <div className="cadastro-campo col-span-2">
          <label htmlFor="descIOR" className="cadastro-rotulo">IOR Description</label>
          <input id="descIOR" className="cadastro-entrada"
            placeholder="Ex.: Importer of Record in the USA"
            {...register("descIOR")} />
        </div>

        <div className="cadastro-campo">
          <label htmlFor="nomeIOR" className="cadastro-rotulo">Name / Company (IOR)</label>
          <input id="nomeIOR" className="cadastro-entrada" {...register("nomeIOR")} />
        </div>

        <div className="cadastro-campo">
          <label htmlFor="emailIOR" className="cadastro-rotulo">Email (IOR)</label>
          <input id="emailIOR" type="email" className="cadastro-entrada" {...register("emailIOR")} />
        </div>

        <div className="cadastro-campo">
          <label htmlFor="tipoIOR" className="cadastro-rotulo">Type (IOR)</label>
          <input id="tipoIOR" className="cadastro-entrada"
            placeholder="Ex.: Company, LLC, Individual"
            {...register("tipoIOR")} />
        </div>

        <div className="cadastro-campo">
          <label htmlFor="telefoneIOR" className="cadastro-rotulo">Phone (IOR)</label>
          <input id="telefoneIOR" className="cadastro-entrada" {...register("telefoneIOR")} />
        </div>

        <div className="cadastro-campo">
          <label htmlFor="paisIOR" className="cadastro-rotulo">Country (IOR)</label>
          <input id="paisIOR" className="cadastro-entrada" {...register("paisIOR")} />
        </div>

        <div className="cadastro-campo">
          <label htmlFor="estadoIOR" className="cadastro-rotulo">State (IOR)</label>
          <input id="estadoIOR" className="cadastro-entrada" {...register("estadoIOR")} />
        </div>

        <div className="cadastro-campo">
          <label htmlFor="cidadeIOR" className="cadastro-rotulo">City (IOR)</label>
          <input id="cidadeIOR" className="cadastro-entrada" {...register("cidadeIOR")} />
        </div>

        <div className="cadastro-campo col-span-2">
          <label htmlFor="enderecoIOR" className="cadastro-rotulo">Address (IOR)</label>
          <input id="enderecoIOR" className="cadastro-entrada" {...register("enderecoIOR")} />
        </div>

        <div className="cadastro-campo">
          <label htmlFor="numeroIOR" className="cadastro-rotulo">Number</label>
          <input id="numeroIOR" className="cadastro-entrada" {...register("numeroIOR")} />
        </div>

        <div className="cadastro-campo">
          <label htmlFor="cod_postalIOR" className="cadastro-rotulo">ZIP Code (IOR)</label>
          <input id="cod_postalIOR" className="cadastro-entrada" inputMode="numeric"
            {...register("cod_postalIOR")} />
        </div>

        <div className="cadastro-campo col-span-2">
          <label htmlFor="state_tax_idIOR" className="cadastro-rotulo">State Tax ID (IOR)</label>
          <input id="state_tax_idIOR" className="cadastro-entrada"
            placeholder="Ex.: exempt / isento"
            {...register("state_tax_idIOR")} />
        </div>
      </div>

      {erro && <div className="cadastro-erro">{erro}</div>}

      <div className="cadastro-acoes">
        <button type="button" className="cadastro-btn-ghost" onClick={onBack} disabled={loading}>
          Back
        </button>
        <button type="button" className="cadastro-btn-ghost" onClick={() => onNext({})} disabled={loading}>
          Skip
        </button>
        <button type="submit" className="cadastro-btn-primario" disabled={loading}>
          Continue
        </button>
      </div>
    </form>
  );
}
